import axios from "axios";
import DateTimeUtil from "../../../utils/date-time.util";

const url = require("../../client_config/config").url;

const state = {
    contentTab: "defaultTab",
    selectedUserPayrollReport: {},
    historyTab: "",
    loadingHistory: true,

    isSavingEditLoading: false,
    tabItems: {},
    selectedCompPanel: [],
    selectedDeductPanel: []
};

const mutations = {
    setContentTab (state, data) {
        state.contentTab = data
    },

    setSelectedUserPayrollReport (state, data) {
        state.selectedUserPayrollReport = data
    },

    setHistoryTab (state, data) {
        state.historyTab = data
    },

    setLoadingHistory (state, data) {
        state.loadingHistory = data
    },

    setSelectedCompPanel (state, data) {
        if (data === null) {
            state.selectedCompPanel = []
        } else if (state.selectedCompPanel.length == 0 && data == 0) {
            state.selectedCompPanel = 0;
        } else {
            state.selectedCompPanel = data == state.selectedCompPanel ? [] : data
        }
    },

    setSelectedDeductPanel (state, data) {
        if (data === null) {
            state.selectedDeductPanel = []
        } else if (state.selectedDeductPanel.length == 0 && data == 0) {
            state.selectedDeductPanel = 0;
        } else {
            state.selectedDeductPanel = data == state.selectedDeductPanel ? [] : data
        }
    },

    setTabItems (state, data) {
        state.tabItems = data
    },

    setIsSavingEditLoading (state, data) {
        state.isSavingEditLoading = data;
    },
};

const actions = {
    // Fetch User Salary Raise History
    async getUserSalaryRaiseHistory ({state}, user) {
        let history = await axios.get(`${url}/raises/getStaffRaiseHistory/${user.Email}`).then((res) => {
            // const users = res.data.users;
            
            // let historyItems = users.filter(usersalary => usersalary.Email === user.Email);

            // // Convert to readable date
            // historyItems = historyItems.map(item => {
            //     const convertedDate = item.RaiseDate ? DateTimeUtil.toLocalDate(item.RaiseDate) : item.RaiseDate;
            //     return {
            //         ...item,
            //         RaiseDate: convertedDate
            //     };
            // });

            // // Filter duplicates
            // historyItems = historyItems.filter((item, index, self) =>
            //     index === self.findIndex(t => t.Raise === item.Raise && t.Rate === item.Rate && t.RaiseDate === item.RaiseDate)
            // );
            // return historyItems

            const staffRaises = res.data;

            staffRaises.map(staffRaise => {
                staffRaise.RaiseDate = DateTimeUtil.toLocalDate(staffRaise.RaiseDate)
            })
            
            return staffRaises
        })

        state.loadingHistory = false
        return history
    },

    // Fetch User Bonus History
    async getStaffUserBonusHistory ({state}, user) {
        let history = await axios.get(`${url}/bonuses/getStaffBonusHistory/${user._id}`).then((res) => {
            const staffBonuses = res.data;
            
            staffBonuses.map(staffBonus => {
                staffBonus.Date = DateTimeUtil.toLocalDate(staffBonus.Date)
            })
            
            return staffBonuses
        })
        
        state.loadingHistory = false
        return history
    },

    // Fetch User Reimbursements
    async getStaffUserReimbursements ({state}, user) {
        let history = await axios.get(`${url}/reimbursements/staff/${user._id}`).then(res => {
            const staffReimbursements = res.data.reimbursements;
            

            staffReimbursements.map(staffReimbursement => {
                staffReimbursement.Date = DateTimeUtil.toLocalDate(staffReimbursement.Date)
            })
            
            return staffReimbursements
        })

        state.loadingHistory = false
        return history
    },

    // Fetch Health Care
    async getStaffUserHealthCareHistory ({state}, user) {
        let history = await axios.get(`${url}/healthcare/getStaffHealthCare/${user._id}`).then(res => {
            const staffHealthCares = res.data;
            

            staffHealthCares.map(staffHealthCare => {
                staffHealthCare.Date = DateTimeUtil.toLocalDate(staffHealthCare.Date)
            })
            
            return staffHealthCares
        })

        state.loadingHistory = false
        return history
    },

    // Fetch Incentives
    async getStaffUserIncentiveHistory ({state}, user) {
        let history = await axios.get(`${url}/incentives/getStaffIncentive/${user._id}`).then(res => {
            const staffIncentives = res.data;
            

            staffIncentives.map(staffIncentive => {
                staffIncentive.Date = DateTimeUtil.toLocalDate(staffIncentive.Date)
            })
            
            return staffIncentives
        })

        state.loadingHistory = false
        return history
    },

    // Fetch User Garnishments
    async getStaffUserGarnishments ({state}, user) {
        let history = await axios.get(`${url}/garnishments/staff/${user._id}`).then(res => {
            const staffGarnishments = res.data.results;

            staffGarnishments.map(staffGarnishment => {
                staffGarnishment.CourtDate = DateTimeUtil.toLocalDate(staffGarnishment.CourtDate)
            })
            
            return staffGarnishments
        })

        state.loadingHistory = false
        return history
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}